import React, { useState, useEffect } from 'react';
import { Translate } from '../../language';
import logoRecoverPassword from '../../img/logo_final_png.png';
import ViewLogin from '../../containers/ViewLogin/ViewLogin';
import { connect } from 'react-redux'
import { sendEmailToPassword } from '../../actions/recoverActions'
import RecoverPasswordView from '../../containers/RecoverPasswordView';



const RecoverPassword = ({ sendEmailToPassword, history, errorType, model, success }) => {

    const [email, setEmail] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)

    useEffect(() => {
        var email = 'email'
        if (errorType !== null && errorType.code === "ERR002") {
            console.log()
            setError(prevError => ({
                ...prevError,
                [email]: Translate('ERR002', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR009") {
            console.log()
            setError(prevError => ({
                ...prevError,
                [email]: Translate('ERR009', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR011") {
            console.log()
            setError(prevError => ({
                ...prevError,
                [email]: Translate('ERR011', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR013") {
            setError(prevError => ({
                ...prevError,
                [email]: Translate('ERR013', 'es')
            }));
        }
    }, [errorType])

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }

    const isEmpty = (e) => {

        const { name, placeholder, value } = e.target;
        setEmail(value)
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        else {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));

            if (name === "email") {
                if ((value.includes("@") && value.includes(".")) === false) {
                    setValidate(false)
                    setError(prevError => ({
                        ...prevError,
                        [name]: Translate('invalidEmail', 'es')
                    }));
                }

            }
        }


    }

    const goToLoginCode = (e) => {
        e.preventDefault()
        console.log()
        sendEmailToPassword(email, history)
    }

    return (

        <ViewLogin
            type='text'
            nameInput='email'
            img={logoRecoverPassword}
            textWelcome={Translate('messageRecoverPassword', 'es')}
            inputValue={email}
            error={error.email}
            onChangeInput={isEmpty}
            onFocusInput={isFocused}
            inputPlaceholder="enterEmail"
            textButton="send"
            actionButton={goToLoginCode}
            textDown=''
            TextlinkDown=''
            linkToDown=''
            isMenuDown={false}
            isRecoverPassword={true}
            textRecoverPasword={'rememberCodeInit'}
            isBackgroundBlue={false}
            isActiveButton={isValidate}
        />

    )
}

const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        errorType: state.recover.errorType, // y lo que retorna map, connect lo envia a Page como Props 
        success: state.recover.success,
        model: state.register.model
    }
}


export default connect(mapStateToProps, { sendEmailToPassword })(RecoverPassword)


